<template>
    <div class="flip">
      <span class="flip-clock-slot" v-bind:style="styles.label">{{ $t(`ct-${property}`) }}</span>
      <span class="flip-clock-piece">
          <span class="flip-clock-card flip-card">
              <b class="flip-card-top" :data-color="appearance.backgroundColor" v-bind:style="styles.number">{{ current }}</b>
              <b class="flip-card-bottom" :data-value="current" :data-color="appearance.backgroundColor" v-bind:style="styles.number"></b>
              <b class="flip-card-back" :data-value="previous" :data-color="appearance.backgroundColor"></b>
              <b class="flip-card-back-bottom" :data-value="previous" :data-color="appearance.backgroundColor" v-bind:style="styles.number"></b>
          </span>
          <span class="flip-clock-divider" v-show="property !== 'seconds'">
            <span class="flip-clock-dot top" v-bind:style="styles.card"></span>
            <span class="flip-clock-dot bottom" v-bind:style="styles.card"></span>
          </span>
      </span>
    </div>
</template>

<script>
export default {
  name: 'TrackerComponent',
  props: ['property', 'time', 'appearance', 'width', 'height'],
  data() {
    return {
      current: 0,
      previous: 0,
      show: false,
      styles: {
        card: {},
        number: {},
        label: {}
      }
    };
  },

  watch: {
    'appearance.fontColorLabel': function(value) {
      this.styles.label = { color: this.appearance.fontColorLabel};
    },
    'time': {
      handler(newValue) {
        this.styles.label = { color: this.appearance.fontColorLabel};
        this.changeTimer(newValue);
      },
      deep: true
    }
    // 'appearance': {
    //   handler() {
    // this.styles.card = { background : this.appearance.backgroundColor};
    // this.styles.number = { color : this.appearance.fontColor, background : this.appearance.backgroundColor};
    // this.styles.label = { color : this.appearance.fontColorLabel};
    //   },
    //   deep: true
    // }
  },

  methods: {
    changeTimer(newValue) {
      if (newValue[this.property] === undefined) {
        this.show = false;
        return;
      }

      var val = newValue[this.property];

      this.show = true;

      val = (val < 0 ? 0 : val);

      if (val !== this.current) {
        this.previous = this.current;
        this.current = val;

        this.$el.classList.remove('flip');
        void this.$el.offsetWidth;
        this.$el.classList.add('flip');
      }
    }
  },

  created() {}
};
</script>

<style lang="scss" scoped>
</style>
